import $ from 'jquery';
import setNav from 'modules/setnav';
import worksMenuToggle from 'modules/worksmenu';
import closeWorksMenu from 'modules/closeworksmenu';
import lazysizes from "lazysizes";
import orb from "modules/morph";

/***** Get it goin' *****/
document.addEventListener('DOMContentLoaded', () => {
  setNav();
  console.log('init loaded');
  worksMenuToggle();
  closeWorksMenu();
  orb();
}, false);



// WEBPACK FOOTER //
// ./source/scripts/scripts/init.js